import {
  BackendServerActionType,
  BodyModel,
  ButtonElementModel,
  ColumnHeaderElementModel,
  DevelopConditionListViewScript,
  DevelopScriptServicePack,
  EditType,
  InputPartsBaseModel,
  LinkElementModel,
  PanelModel,
  PanelType,
  ViewType,
} from '@ktvs8/gocoo-engine-front-end';
export class MProgramConditionList implements DevelopConditionListViewScript {
  /**
   * スクリプト名
   */
  scriptName: string = 'MProgramConditionList';

  /**
   * 初期処理
   * @param panelModels パネルのモデルリスト
   * @param service gocoo-engineで使用できるサービス
   */
  init(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {}

  /**
   * 終了処理
   * @param panelModels パネルのモデルリスト
   * @param service gocoo-engineで使用できるサービス
   */
  destroy(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {}

  /**
   * ボタンを押下した時の処理
   * @param panelModels パネルのモデルリスト
   * @param clickedButtonElement 押下したボタンの要素モデル
   * @param service  gocoo-engineで使用できるサービス
   */
  clickedButton(
    panelModels: Map<PanelType, PanelModel>,
    clickedButtonElement: ButtonElementModel,
    service: DevelopScriptServicePack
  ): void {
    if (clickedButtonElement.id.includes('NewButton')) {
      service.moveViewService.moveViewInGocooEngine(ViewType.Edit, 'MProgram', EditType.New, {});
      //Edit画面を開く処理
    }
  }

  /**
   * リンクを押下した時の処理
   * @param panelModels パネルのモデルリスト
   * @param clickedLinkElement 押下したリンクの要素モデル
   * @param service  gocoo-engineで使用できるサービス
   */
  clickedLink(
    panelModels: Map<PanelType, PanelModel>,
    clickedLinkElement: LinkElementModel,
    service: DevelopScriptServicePack
  ): void {}
  /**
   * input-partsのイベント発生時の処理
   * @param inputPartsModel イベントが発生したinput-partsのモデル
   * @param panelModels パネルのモデルリスト
   * @param service gocoo-engineで使用できるサービス
   */
  inputPartsEvent(
    inputPartsModel: InputPartsBaseModel,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): void {}

  /**
   * 一覧画面のデータを取得した後の処理
   * @param bodyModel 一覧部分のボディー
   * @param headers 一覧部分のヘッダー
   */
  fetchedList(bodyModel: BodyModel, headers: ColumnHeaderElementModel[]): void {
    this.setSpotProgram(bodyModel);
  }
  /**
   * バリデーションチェック
   * @param targetValidationPanel
   * @param actionType
   * @param panelModels
   * @param service
   */
  validationCheck(
    targetValidationPanel: PanelType,
    actionType: BackendServerActionType,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): boolean {
    return true;
  }

  /**
   * 単発番組のマークを置き換える
   * @param listPanel
   */
  setSpotProgram(bodyModel: BodyModel): void {
    bodyModel.rows.forEach((row) => {
      var spotCell = row.getCell('IsSpotProgram');
      var programCell = row.getCell('ProgramName');
      if (spotCell !== undefined && programCell !== undefined) {
        if (spotCell.cellModel.value === true) {
          programCell.cellModel.class.push('pre-program');
        }
      }
    });
  }
}
